<valg-dk-page-layout
  [election]="election"
  [links]="links"
  [filterLinks]="links"
  [sideNavTitleType]="sideNavTitleType"
  [parentLinkType]="parentLinkType">
  <valg-dk-breadcrumbs></valg-dk-breadcrumbs>
    <h1 class="h2 mt-0 mb-8 hyphenate">
      {{ 'page.election_overview.heading_with_date' | translate: {election: election?.electionName, date: ( election?.electionDate | date: 'longDate' )} }}
    </h1>
    <div class="row">
      <div class="col-12 col-lg-6" *ngIf="election?.isDisplayingCards">
        <valg-card [border]="true" [custom]="true" height="492px">
          <valg-dk-count-status [resultSummary]="resultSummary" title="count_status.title_overview_page" [resultType]="resultType" [candidateDataLoadState]="candidateDataLoadState" [updated]="countStatusUpdated" [data]="countStatus"></valg-dk-count-status>
        </valg-card>
        <ng-container *ngTemplateOutlet="valgDkElectionMapCard; context: { isDesktopView: false }"></ng-container>
        <valg-card [border]="true" [custom]="true" class="p-0" height="492px">
          <valg-dk-party-voting-status-summary [resultSummary]="resultSummary" [candidateDataLoadState]="candidateDataLoadState" [partyStatus]="partyStatus">

          </valg-dk-party-voting-status-summary>
        </valg-card>
        <ng-container *ngTemplateOutlet="topCandidatesCard; context: { isDesktopView: true }"></ng-container>
      </div>
      <div class="col-12 col-lg-6">
        <ng-container *ngTemplateOutlet="valgDkElectionMapCard; context: { isDesktopView: true }"></ng-container>

        <valg-card [border]="true" [custom]="true" class="p-0" *ngIf="electoralCoalitions && electoralCoalitions.length > 0">
          <valg-dk-electoral-coalition [data]="electoralCoalitions"></valg-dk-electoral-coalition>
        </valg-card>
        <ng-container *ngTemplateOutlet="topCandidatesCard; context: { isDesktopView: false }"></ng-container>
        <valg-card [border]="true" [custom]="true" class="p-0" height="492px">
          <valg-table
            [columnDefinition]="latestUpdatesDistrictColumnDef"
            [data]="latestUpdates"
            [itemName]="'election_overview.latest_updates.table.item_name' | translate"
            [title]="'election_overview.latest_updates.title' | translate"
            [hasPagination]="false"
            [displayItemCount]="false"
            [hasMainActionButton]="false">
            <h2 class="m-0 text--f20 text--500">{{ 'election_overview.latest_updates.title' | translate }}</h2>
          </valg-table>
        </valg-card>
      </div>
    </div>

</valg-dk-page-layout>

<ng-template #valgDkElectionMapCard let-isDesktopView="isDesktopView">
  <valg-card [ngClass]="isDesktopView ? 'd-none d-lg-block': 'd-lg-none'" [border]="true" [custom]="true" *ngIf="election?.isDisplayingMap && election">
    <h2 class="card-heading mb-0">{{ 'map.title.status_nomination_districts' | translate }}</h2>
    <valg-dk-election-map
      (areaClicked)="onAreaClick($event)"
      [electionYear]="election.electionYear"
      [electionType]="election.electionType"
      [mapAreasMapping]="mapAreasMapping">
    </valg-dk-election-map>
  </valg-card>
</ng-template>

<ng-template #topCandidatesCard let-isDesktopView="isDesktopView">
  <valg-card [ngClass]="isDesktopView ? 'd-none d-lg-block': 'd-lg-none'" [border]="true" [custom]="true" class="p-0">
    <valg-dk-top-candidates [resultType]="resultType" [data]="topCandidates"></valg-dk-top-candidates>
  </valg-card>
</ng-template>
